/**
 * Sanitize input fields - removes dangerous tags while allowing safe HTML
 * Works on both typing and paste operations
 * 
 * Use this for input fields where HTML is allowed but scripts should be blocked
 * 
 * Blocks (removed automatically):
 * - <script>, <iframe>, <object>, <embed>, <form>, <style> tags
 * - All event handler attributes (onclick, onerror, onload, etc.)
 * 
 * Allows:
 * - All other HTML tags (<div>, <p>, <a>, <img>, etc.)
 * - Plain < and > characters
 */
export const sanitizeInput = (dirty) => {
  if (!dirty) return '';
  
  // Remove dangerous tags (both complete and incomplete/unclosed)
  let cleaned = dirty;
  
  // Remove script tags (complete with closing tag) - using [\s\S] to match newlines
  cleaned = cleaned.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');
  // Remove unclosed/incomplete script tags
  cleaned = cleaned.replace(/<script\b[^>]*>/gi, '');
  cleaned = cleaned.replace(/<\/script>/gi, '');
  
  // Remove iframe tags (complete with closing tag)
  cleaned = cleaned.replace(/<iframe\b[^>]*>[\s\S]*?<\/iframe>/gi, '');
  // Remove unclosed/incomplete iframe tags
  cleaned = cleaned.replace(/<iframe\b[^>]*>/gi, '');
  cleaned = cleaned.replace(/<\/iframe>/gi, '');
  
  // Remove object tags (complete with closing tag)
  cleaned = cleaned.replace(/<object\b[^>]*>[\s\S]*?<\/object>/gi, '');
  // Remove unclosed/incomplete object tags
  cleaned = cleaned.replace(/<object\b[^>]*>/gi, '');
  cleaned = cleaned.replace(/<\/object>/gi, '');
  
  // Remove embed tags (self-closing or with closing tag)
  cleaned = cleaned.replace(/<embed\b[^>]*>/gi, '');
  cleaned = cleaned.replace(/<\/embed>/gi, '');
  
  // Remove form tags (complete with closing tag)
  cleaned = cleaned.replace(/<form\b[^>]*>[\s\S]*?<\/form>/gi, '');
  // Remove unclosed/incomplete form tags
  cleaned = cleaned.replace(/<form\b[^>]*>/gi, '');
  cleaned = cleaned.replace(/<\/form>/gi, '');
  
  // Remove style tags (complete with closing tag)
  cleaned = cleaned.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '');
  // Remove unclosed/incomplete style tags
  cleaned = cleaned.replace(/<style\b[^>]*>/gi, '');
  cleaned = cleaned.replace(/<\/style>/gi, '');
  
  // Remove event handler attributes from any remaining tags
  cleaned = cleaned.replace(/\s*on\w+\s*=\s*["'][^"']*["']/gi, '');
  cleaned = cleaned.replace(/\s*on\w+\s*=\s*[^\s>]*/gi, '');
  
  return cleaned;
};